/**
 * <pvz-gift-wrap>
 *
 * カートページのギフトラッピング ON/OFF。
 * チェックでラッピング商品を数量 1 でカートに入れ、外すと数量 0 (削除) にする。
 * 更新後は <cart-items> と同じセクション (商品一覧・合計・カートアイコン) を描き直す。
 *
 * Markup: snippets/pvz-gift-wrap.liquid
 *   <pvz-gift-wrap data-variant-id="123">
 *     <input type="checkbox">
 *   </pvz-gift-wrap>
 */
if (!customElements.get('pvz-gift-wrap')) {
  customElements.define(
    'pvz-gift-wrap',
    class PvzGiftWrap extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="checkbox"]');
        if (!this.input) return;

        this.input.addEventListener('change', (event) => {
          // 親の <cart-items> が change を拾うと数量変更として処理してしまうので止める
          event.stopPropagation();
          this.update(this.input.checked);
        });
      }

      async update(checked) {
        const cartItems = this.closest('cart-items');
        const sections = cartItems ? cartItems.getSectionsToRender() : [];

        this.input.disabled = true;
        this.classList.add('is-loading');

        try {
          const body = JSON.stringify({
            updates: { [this.dataset.variantId]: checked ? 1 : 0 },
            sections: sections.map((section) => section.section),
            sections_url: window.location.pathname,
          });
          const response = await fetch(routes.cart_update_url, { ...fetchConfig(), body });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || state.message);

          // ラッピングだけが入っていたカートで外すと空になる
          const isEmpty = state.item_count === 0;
          if (cartItems) cartItems.classList.toggle('is-empty', isEmpty);
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', isEmpty);

          // このブロック自体も描き直しで置き換わる
          sections.forEach((section) => {
            const container = document.getElementById(section.id);
            const html = state.sections && state.sections[section.section];
            if (!container || !html) return;
            const target = container.querySelector(section.selector) || container;
            target.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
          });

          // source を cart-items にして、<cart-items> 側の再取得 (二重描画) を避ける
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
        } catch (error) {
          console.error(error);
          this.input.checked = !checked;
          const errors = document.getElementById('cart-errors');
          if (errors) errors.textContent = window.cartStrings.error;
        } finally {
          this.input.disabled = false;
          this.classList.remove('is-loading');
        }
      }
    }
  );
}
